import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tabs, Tab } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import Instalments from './Instalments';
import Payments from './Payments';


class InstalmentPayments extends Component {
	constructor(props) {
		super(props);
		this.handleTabSelect = this.handleTabSelect.bind(this);
	}

	handleTabSelect(key) {
		this.props.history.replace(`/instalmentPayments/${key}`);
	}

	render() {
		const { selectedTab, t } = this.props;
		return <Tabs defaultActiveKey={selectedTab} id='instalment-payments-tabs' onSelect={this.handleTabSelect}>
			<Tab eventKey='orders' title={t('InstalmentPayments_Tab_Orders')}>
				<Payments />
			</Tab>
			<Tab eventKey='instalments' title={t('InstalmentPayments_Tab_Instalments')}>
				<Instalments />
			</Tab>
		</Tabs>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const selectedTab = ownProps.match.params.tab || 'orders';

	return {
		selectedTab
	};
};

export default connect(mapStateToProps, {
})(withTranslation()(InstalmentPayments));